import { CompanyAccountModelDto } from '@treasury/api/channel';
import { CompanyAccount } from '@treasury/domain/company/company-account.entity';
import {
    amountRange,
    checkRange,
    dateRangePickerDefaultToday,
    list,
} from '@treasury/policy/primitives';

export const fields = {};

export const filters = (transactionAccounts: CompanyAccountModelDto[]) => [
    {
        field: 'accounts',
        fieldType: list.with
            .options({
                fetch: async () => transactionAccounts,
                text: 'accountDisplayLabel',
                value: record => record as any,
            })
            .with.hashFunction((company: CompanyAccount) => {
                return company.id?.toString();
            })
            .with.multipleValues()
            .with.label('Accounts')
            .thatIs.required(),
        value: transactionAccounts,
    },
    {
        field: 'dateRange',
        fieldType: dateRangePickerDefaultToday.with.label('Date'),
        value: 'today',
    },
    {
        field: 'checkNumber',
        fieldType: checkRange.with
            .label('Check Number')
            .thatIs.segmented()
            .thatHas.options([
                { text: 'Specific', value: 'Specific #' },
                { text: 'Range', value: 'range' },
            ])
            .with.placeholder('check number'),
        value: ['Specific #', 0],
    },
    {
        field: 'amountRange',
        fieldType: amountRange.thatIs
            .segmented()

            .and.multipleValues()
            .thatHas.options([
                { text: 'Specific', value: 'Specific Amount' },
                { text: 'Range', value: 'Range' },
            ])
            .thatHas.label('Amount')
            .as.tag('omega-range'),
        value: ['Specific Amount', 0],
    },
];

export const columns = [];
